export class LoginContext {
	public token: string = null;
	public username: string;

	public get isAuth(): boolean {
		return this.token != null;
	}
}